import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';

import { task } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/for/default';
import A11yScanner from 'umg-ember-backend/components/record-detail/forms/a11y-scanner';
import Toolbar from 'umg-ember-backend/components/record-detail/toolbar';
import Button from 'umg-ember-backend/components/ui/button';
import Window from 'umg-ember-backend/components/ui/window';
import recordHeadlineOrNew from 'umg-ember-backend/helpers/record-headline-or-new';
import recordOverline from 'umg-ember-backend/helpers/record-overline';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class RecordDetailForA11yScannerComponent extends Component {
  // Services
  @service fetch;
  @service recordStatus;

  // Getter and setter
  get isDisabled() {
    return this.recordStatus.isDisabled(this.args.model);
  }

  // Functions
  startScan = task(async (model) => {
    try {
      const savedModel = await this.history.saveModel(model);

      if (!savedModel) {
        return;
      }

      const response = await this.fetch.post(
        `/a11y/scanners/${savedModel.id}/start`,
      );

      await this.store.pushPayload(response);
      this.flashMessages.success(
        'record_detail.for.a11y_scanner.start_scan_success',
      );
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  });

  // Template
  <template>
    <Window
      @onBodyScroll={{fn (mut this.scrollPosition)}}
      @scrollPosition={{this.scrollPosition}}
      @isLoading={{@model.isLoading}}
      data-test-record-detail='a11y-scanner'
    >
      <:overline>
        {{recordOverline @model}}
      </:overline>

      <:title>
        {{recordHeadlineOrNew @model}}
      </:title>

      <:toolbar>
        <Toolbar
          @isCompact={{this.isScrolled}}
          @model={{@model}}
          @primaryActions={{hash
            onCancel=this.transitionToPrevBreadcrumb
            onPublish=(fn this.publishRecord @model)
            onSave=(fn this.saveRecord @model)
            onSaveAndUnload=(fn this.saveAndUnloadRecord @model)
          }}
          @secondaryActions={{hash
            onDeleteRecord=(fn this.deleteRecordInDetail @model)
            onBlock=(fn this.blockRecord @model)
          }}
        >
          <:additonalPrimaryActions>
            <Button
              @style={{if @model.hasRunningScan 'grey' 'active'}}
              @label={{t 'record_detail.for.a11y_scanner.start_scan'}}
              @icon='share'
              @tooltip={{if
                @model.hasRunningScan
                (t 'record_detail.for.a11y_scanner.already_started')
                null
              }}
              @disabled={{or this.isDisabled @model.hasRunningScan}}
              {{on 'click' (perform this.startScan @model)}}
            />
          </:additonalPrimaryActions>
        </Toolbar>
      </:toolbar>

      <:body>
        <A11yScanner
          @model={{@model}}
          @recordType={{getRecordType @model}}
          @onSaveRecord={{fn this.saveRecord @model}}
          @showErrors={{this.history.showErrors}}
        />
      </:body>
    </Window>
  </template>
}
